module.exports = __webpack_public_path__ + "static/img-01.f7925df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/boyajian/img-01.jpg
// module id = 85
// module chunks = 88197199937824 101002416063330 213720915766396